function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_21",
  "data-name": "Group 21",
  transform: "translate(639.881 -1246.719)"
}, React.createElement("rect", {
  id: "Rectangle_7",
  "data-name": "Rectangle 7",
  width: 62.886,
  height: 15.532,
  transform: "translate(-639.881 1246.719)"
}), React.createElement("rect", {
  id: "Rectangle_8",
  "data-name": "Rectangle 8",
  width: 62.886,
  height: 15.533,
  transform: "translate(-639.881 1273.747)"
}));

var SvgFeedView2 = function SvgFeedView2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 62.886,
    height: 42.561,
    viewBox: "0 0 62.886 42.561",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFeedView2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feed_view-2.d37dc753.svg";
export { ForwardRef as ReactComponent };